function ItemScroll(act, actid) {
  const box = document.getElementById(actid);
  if (act == "L") {
    box.scrollBy({ left: -300, behavior: "smooth" });
  } else {
    box.scrollBy({ left: 300, behavior: "smooth" });
  }
}
